module.exports = __webpack_public_path__ + "static/media/PlantTank.59d1001e.svg";